<template>
  <div class="ln-phone-login">
    <Form ref="form">
      <Field
        v-model="phone"
        placeholder="请输入您的11位手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }]"
      >
        <i slot="left-icon" class="iconfont iconphone"></i>
      </Field>
      <check-code v-model="code" :params="codeParams"></check-code>

      <div class="bottom">
        <Row class="login-row">
          <Button class="login-btn" block type="info" native-type="submit" @click="login"> 进入游戏 </Button>
        </Row>
        <Row class="login-row" gutter="10">
          <Col span="12">
            <Button block type="info" native-type="button" @click="guestLogin">快速注册</Button>
          </Col>
          <Col span="12"><Button block type="info" @click="register">手机注册</Button></Col>
        </Row>

        <Row class="login-row link-wrap" style="justify-content: space-between">
          <span style="flex: 1"></span>
          <span style="flex: 1; text-align: right" class="link" @click="forgetPass">忘记密码?</span>
        </Row>

        <Row class="login-row link-wrap" style="justify-content: center">
          <AgreeRegister v-model="agree"></AgreeRegister>
          <span style="font-size: 13px; margin-top: 7px; margin-left: 5px">同意游戏</span
          ><span class="link" style="vertical-align: center; margin-left: 0px; margin-top: 7px" @click="openProtocal(1)"
            >《用户协议》</span
          >
          <span style="font-size: 13px; margin-top: 7px">及</span>
          <span style="font-size: 13px; margin-top: 7px" @click="openProtocal(2)" class="link">《隐私协议》</span>
        </Row>
      </div>
    </Form>

    <!-- 用户协议弹窗 -->
    <div v-if="isProto" class="lngame_proto">
      <div class="lngame_proto_con" style="height: 100%; width: 100%">
        <div style="height: 90%; padding: 15px">
          <iframe :src="userProtocol" style="width: 100%; height: 100%" frameborder="0"></iframe>
        </div>
      </div>
      <van-icon
        style="position: absolute; right: 0; top: 0; right: 10px; top: 10px; z-index: 3000"
        name="cross"
        @click="closeProto"
      />
    </div>
  </div>
</template>

<script>
import { Form, Field, Button, Col, Row, Dialog } from 'vant';
import cookies from '@/cookies';
import { commonMixin } from '@/mixin';
import AgreeRegister from '@/components/AgreeRegister';
import CheckCode from '@/components/CheckCode';
import server from '@/server';
import channelServer from '@/server/channelServer';
import { getUrlParams } from '@/utils';
export default {
  name: 'ln-phone-login',
  mixins: [commonMixin],
  components: { Form, Field, Col, Button, Row, CheckCode, AgreeRegister },
  data() {
    return {
      phone: '',
      code: '',
      isProto: false,
      agree: Boolean(localStorage.getItem('agreeProt')) || false,
      clickTimer: null,
      clickGuestTimer: null,
    };
  },
  computed: {
    codeParams() {
      return {
        mobile: this.phone,
        type: 1 /* 注册 */,
      };
    },
  },
  created() {
    if (localStorage.getItem('login_type') == 'phone') {
      this.phone = localStorage.getItem('phone') || '';
    }
  },
  methods: {
    login() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      if (this.clickTimer) clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => {
        this.formCheck('form').then(() => {
          const params = {
            mobile: this.phone,
            code: this.code,
          };
          this.$store.commit('SET_USERPHONE', this.phone);
          if (localStorage.getItem('lnUserAccount') && localStorage.getItem('lnUserPass')) {
            this.$store.commit('SET_USER_INFO', {
              name: localStorage.getItem('lnUserAccount'),
              pwd: localStorage.getItem('lnUserPass'),
            });
          }
          server.loginPhone(params);
        });
      }, this.$store.state.button_interval);
    },
    guestLogin() {
      if (!this.agree) {
        Dialog.alert({ message: '请先同意用户隐私协议' });
        return;
      }
      if (this.clickGuestTimer) clearTimeout(this.clickGuestTimer);
      this.clickGuestTimer = setTimeout(() => {
        this.oldBtn = false;
        cookies.setItem('userAccount', this.username);
        cookies.setItem('userPass', this.password);
        this.$store.commit('SET_COMPNAME', '快速注册');
        this.$store.commit('SET_LOGINTYPE', 2);
        channelServer.guestLogin().then((data) => {
          this.username = localStorage.getItem('lnUserAccount') || this.user.account;
          this.password = localStorage.getItem('lnUserPass') || this.user.passwd;
          localStorage.setItem('lnUserAccount', data.account);
          // let IV = data.passwd.slice(0, 16);
          // let data_pwd = data.passwd.slice(16, data.passwd.length);
          // console.log(AES.decrypt(data_pwd, 'LN_85%@A6f*&0d!k', IV))
          // localStorage.setItem('lnUserPass', AES.decrypt(data_pwd, 'LN_85%@A6f*&0d!k', IV));
          this.$store.commit('SET_USER_INFO', { name: data.account, pwd: data.passwd });
          localStorage.setItem('lnUserPass', '******');
          server.autoLogin();
        });
      }, this.$store.state.button_interval);
    },
    register() {
      this.changeComponent('PhoneRegister');
    },
    // 打开用户协议
    openProtocal(type) {
      this.isProto = true;
      const host = window.location.host;
      const noLnDomain = `https://${host}`;
      const prodBaseUrl = location.host === 'apisdk.lnqwe.com' ? 'https://apisdk.lnqwe.com' : noLnDomain;
      this.userProtocol =
        type == 1
          ? `${prodBaseUrl}/uc/user/user_protocol?appid=${getUrlParams('appid')}`
          : `${prodBaseUrl}/uc/user/privacy_protocol?appid=${getUrlParams('appid')}`;
    },
    closeProto() {
      this.isProto = false;
    },
    forgetPass() {
      this.changeComponent('ForgetPassword');
      this.$store.commit('SAVECURRCOMP', 'PhoneLogin');
    },
  },
};
</script>
<style lang="scss">
/* @import url() */
.ln-phone-login {
}
.lngame_proto {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 2002;
  background: rgba(0, 0, 0, 0.4);
}

.lngame_proto_con {
  width: 100%;
  height: 350px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
